import WinkPaidStudy from '../../../../features/wink/winkexperience/WinkPaidStudy';

const PaidStudyStep01Page = ({ history }) => {
    return (
        <>
            <WinkPaidStudy history={history} />
        </>
    );
};

export default PaidStudyStep01Page;
